<script setup lang="ts">
    import type { IHSL } from '@/typescript/interfaces/colors';

    const hsl = defineModel<IHSL>({ default: { h: 0, s: 0, l: 0 } });

    function updateHsl(newHsl: IHSL) {
        hsl.value = newHsl;
    }
</script>

<template>
    <div class="flex w-full flex-row justify-around gap-2">
        <input
            id="hsl-h"
            :aria-label="$t('colorpicker_aria_hsl_hue')"
            :value="hsl.h"
            class="border-border h-8 w-1/3 rounded-md border text-center"
            min="0"
            max="360"
            @input="
                updateHsl({
                    h: Number(($event.target as HTMLInputElement).value) ?? hsl.h,
                    s: hsl.s,
                    l: hsl.l,
                })
            "
        />
        <input
            id="hsl-s"
            :aria-label="$t('colorpicker_aria_hsl_saturation')"
            :value="hsl.s"
            class="border-border h-8 w-1/3 rounded-md border text-center"
            min="0"
            max="100"
            @input="
                updateHsl({
                    s: Number(($event.target as HTMLInputElement).value),
                    h: hsl.h,
                    l: hsl.l,
                })
            "
        />
        <input
            id="hsl-l"
            :aria-label="$t('colorpicker_aria_hsl_lightness')"
            :value="hsl.l"
            class="border-border h-8 w-1/3 rounded-md border text-center"
            min="0"
            max="100"
            @input="
                updateHsl({
                    l: Number(($event.target as HTMLInputElement).value),
                    h: hsl.h,
                    s: hsl.s,
                })
            "
        />
    </div>
</template>
